import { createReducer, on } from '@ngrx/store';
import {  setReady } from './db.actions';
import { DbProp } from './db.prop';

export const initialState: DbProp = {
  is_ready: false
};

const _dbReducer = createReducer(
  initialState,
  on(setReady, (state, value) => {
    return value;
  })
);

export function dbReducer(state, action) {
  return _dbReducer(state, action);
}